import { entryPoint } from "../util";
import { TryFarmbot } from "./try_farmbot";

entryPoint(TryFarmbot);
